import EmployeeSurveyForm from "./EmployeeSurveyForm";

function App(){
  return(
    <>
    <EmployeeSurveyForm/>
    </>
  )  
}
export default App;